var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAddFile48Line = function SvgIconAddFile48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 17.779h3.1v4.46h3.4v-6.16c0-.11-.01-.22-.03-.33-.03-.15-.08-.28-.15-.41-.02-.03-.03-.07-.05-.1-.07-.13-.16-.25-.27-.36l-6-6c-.11-.11-.23-.19-.36-.27-.03-.02-.06-.04-.1-.05-.13-.06-.27-.12-.41-.15-.11-.02-.22-.03-.33-.03H16.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h7.63v-3.4H16.6a1.9 1.9 0 0 1-1.9-1.9v-18.8c0-1.05.85-1.9 1.9-1.9h10.7v3.1c0 1.6 1.3 2.9 2.9 2.9Zm.5-3.4v-.2l.2.2h-.2Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.07 31.299H36.7v-5.37h-3.4v5.37h-5.37v3.4h5.37v5.37h3.4v-5.37h5.37v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconAddFile48Line;